import {
    FETCH_DISABLED_RULES_SUCCESS,
    FETCH_ENABLED_RULES_SUCCESS,
    FETCH_RULES,
    FETCH_RULES_FAIL,
    FETCH_RULES_SUCCESS
} from './actionTypes';

const initialState = {
    ruleCategory: '',
    data: {
        enabled: [],
        disabled: []
    },
    loaded: false,
    loading: false,
    error: null
};

export function rulesReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_RULES: {
            return {
                ...state,
                ruleCategory: action.payload,
                loading: true
            };
        }
        case FETCH_RULES_SUCCESS: {
            return {
                ...state,
                loading: false,
                loaded: true
            };
        }
        case FETCH_RULES_FAIL: {
            return {
                ...state,
                error: action.payload,
                loaded: false
            };
        }
        case FETCH_ENABLED_RULES_SUCCESS: {
            return {
                ...state,
                data: {
                    ...state.data,
                    enabled: action.payload
                }
            };
        }

        case FETCH_DISABLED_RULES_SUCCESS: {
            return {
                ...state,
                data: {
                    ...state.data,
                    disabled: action.payload
                }
            };
        }
        default: {
            return state;
        }
    }
}
